import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=8528f44c&"
import script from "./logo.vue?vue&type=script&lang=js&"
export * from "./logo.vue?vue&type=script&lang=js&"
import style0 from "./logo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports